/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_Plans_Business_DescriptionInputs */

const es_components_upgrade_plan_modal_plans_business_description = /** @type {(inputs: Components_Upgrade_Plan_Modal_Plans_Business_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pensado para operaciones con alto volumen y múltiples flujos de trabajo.`)
};

const en_components_upgrade_plan_modal_plans_business_description = /** @type {(inputs: Components_Upgrade_Plan_Modal_Plans_Business_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Designed for higher-volume operations and multi-team workflows.`)
};

/**
* | output |
* | --- |
* | "Designed for higher-volume operations and multi-team workflows." |
*
* @param {Components_Upgrade_Plan_Modal_Plans_Business_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_plans_business_description = /** @type {((inputs?: Components_Upgrade_Plan_Modal_Plans_Business_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Plans_Business_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_plans_business_description(inputs)
	return en_components_upgrade_plan_modal_plans_business_description(inputs)
});
export { components_upgrade_plan_modal_plans_business_description as "components.upgrade_plan_modal.plans.business.description" }